import React from 'react';
import { Toaster } from 'sonner';
import { PricingRegionProvider } from '../contexts/PricingRegionContext';
import { CartProvider } from '../contexts/CartContext';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';
import Cart from './Cart';

const PublicPageShell = ({ children, mainClassName = '' }) => (
  <PricingRegionProvider>
    <CartProvider>
      <div className="min-h-screen w-full overflow-x-hidden bg-black">
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: '#121212',
                color: '#fff',
                border: '1px solid rgba(255,255,255,0.1)',
              },
            }}
          />
          <Header />
          <main className={mainClassName}>{children}</main>
          <Footer />
          <FloatingWhatsApp />
          <Cart />
      </div>
    </CartProvider>
  </PricingRegionProvider>
);

export default PublicPageShell;
